import { doctorRegisterActions } from '../../../actions/user/doctor/register';

// Initial state for doctor registration
const initialState = {
  loading: false,
  doctorData: null,
  error: null
};

// The reducer function
const doctorRegisterReducer = (state = initialState, action) => {
  switch (action.type) {
    case doctorRegisterActions.REGISTER_DOCTOR.REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case doctorRegisterActions.REGISTER_DOCTOR.SUCCESS:
      return {
        ...state,
        loading: false,
        doctorData: action.payload, // Store data to api
        error: null
      };

    case doctorRegisterActions.REGISTER_DOCTOR.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    case doctorRegisterActions.REGISTER_DOCTOR.RESET:
      return {
        ...state,
        loading: false,
        doctorData: null,
        error: null
      };

    default:
      return state;
  }
};

export default doctorRegisterReducer;
